import React, { useState } from 'react'
import NotificationPresetsTab from './NotificationPresetsTab'
import NotificationsReEngageTab from './NotificationsReEngageTab'
import NotificationsTestPushTab from './NotificationsTestPushTab'
import NotificationsMyPlacesTab from './NotificationsMyPlacesTab'
import NotificationsLogTab from './NotificationsLogTab'

type NotificationsTab = 'presets' | 'log' | 'myplaces' | 'reengage' | 'test'

const NotificationsPage = () => {
  const [activeTab, setActiveTab] = useState<NotificationsTab>('presets')

  return (
    <div className="roles-container notifications-page">
      <div className="roles-header">
        <h2>Notifications</h2>
      </div>

      <div className="tab-bar" style={{ marginBottom: '16px' }}>
        <div style={{ display: 'flex', gap: '24px' }}>
          <button
            type="button"
            className={activeTab === 'presets' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('presets')}
          >
            Presets
          </button>
          <button
            type="button"
            className={activeTab === 'log' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('log')}
          >
            Notification Log
          </button>
          <button
            type="button"
            className={activeTab === 'myplaces' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('myplaces')}
          >
            My Places
          </button>
          <button
            type="button"
            className={activeTab === 'reengage' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('reengage')}
          >
            Re-engage
          </button>
          <button
            type="button"
            className={activeTab === 'test' ? 'tab active' : 'tab'}
            onClick={() => setActiveTab('test')}
          >
            Test push
          </button>
        </div>
      </div>

      {activeTab === 'presets' ? (
        <NotificationPresetsTab />
      ) : activeTab === 'log' ? (
        <NotificationsLogTab />
      ) : activeTab === 'myplaces' ? (
        <NotificationsMyPlacesTab />
      ) : activeTab === 'reengage' ? (
        <NotificationsReEngageTab />
      ) : (
        <NotificationsTestPushTab />
      )}
    </div>
  )
}

export default NotificationsPage
